import { render, staticRenderFns } from "./ColmenaNueva.vue?vue&type=template&id=0e09c13d&scoped=true&"
import script from "./ColmenaNueva.vue?vue&type=script&lang=js&"
export * from "./ColmenaNueva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e09c13d",
  null
  
)

export default component.exports